import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../services/RestApiService';

export type EditDrillPathFieldDescriptionRequestParams = {
  readonly datasourceLuid: string;
  readonly fullyQualifiedFieldName: string;
  readonly description: string;
}

export type EditDrillPathFieldDescriptionRequestBody = {
readonly 'drill_path_name': string;
  readonly 'drill_path_edit_model': {
    readonly 'user_description_text': string;
  };
};

export type EditDrillPathFieldDescriptionErrorResponse = {
  'message': string;
  'httpErrorCode': number;
}

export type EditDrillPathFieldDescriptionResponse = EditDrillPathFieldDescriptionErrorResponse | {};

export function getEditFieldDescriptionRequestConfig(params: EditDrillPathFieldDescriptionRequestParams): JsonRestApiRequestConfig {
  return {
    restApiVersion: '-', // TAG api "version" string is -
    httpMethod: 'PATCH',
    endpoint: `datasourcemodel/datasources/${params.datasourceLuid}/drillpath`,
    serverWideRequest: true
  };
}

function getEditFieldDescriptionRequestBody({fullyQualifiedFieldName: fieldFullyQualifiedName, description}: EditDrillPathFieldDescriptionRequestParams): EditDrillPathFieldDescriptionRequestBody {
  return {
    'drill_path_name': fieldFullyQualifiedName,
    'drill_path_edit_model': {
      'user_description_text': description
    }
  };
}

export function callViaApiService(params: EditDrillPathFieldDescriptionRequestParams) {
  return makeJsonRestApiRequest<EditDrillPathFieldDescriptionRequestBody, EditDrillPathFieldDescriptionErrorResponse>({
    config: getEditFieldDescriptionRequestConfig(params),
    request: getEditFieldDescriptionRequestBody(params),
  });
}
